import { render } from "./H5new.vue?vue&type=template&id=4e0345e5&scoped=true"
import script from "./H5new.vue?vue&type=script&lang=js"
export * from "./H5new.vue?vue&type=script&lang=js"

import "./H5new.vue?vue&type=style&index=0&id=4e0345e5&scoped=true&lang=css"

import exportComponent from "D:\\others\\ysj\\leer\\wisdom\\html\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e0345e5"]])

export default __exports__